module.exports = __webpack_public_path__ + "static/media/texture (42).0c214171.jpg";